import { render } from "./CadastroEmpresaClienteDialog.vue?vue&type=template&id=7b8212c7&scoped=true"
import script from "./CadastroEmpresaClienteDialog.vue?vue&type=script&lang=js"
export * from "./CadastroEmpresaClienteDialog.vue?vue&type=script&lang=js"

import "./CadastroEmpresaClienteDialog.vue?vue&type=style&index=0&id=7b8212c7&scoped=true&lang=css"
import "./CadastroEmpresaClienteDialog.vue?vue&type=style&index=1&id=7b8212c7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b8212c7"]])

export default __exports__